import { ApiService } from "../../../services/ApiService";
import {
  GET_EMPLOYEE_DETAILS,
  GET_DISCIPLINARY_CASE,
  CREATE_EMPLOYEE,
  GET_EMPLOYEE,
  GET_ALL_CASE,
  GET_INACTIVE_EMPLOYEE,
  GET_WHO_IS_OUT_EMPLOYEE,
} from "../../actionTypes";

export class employeeMngtThunk {
  static createEmployee(data) {
    return async (dispatch) => {
      try {
        const response = await ApiService.post("users/create-employee", data);
        if (response.data) {
          dispatch({
            type: CREATE_EMPLOYEE,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }
  static getEmployeesDetails() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get("users/get-all");
        if (response.data) {
          dispatch({
            type: GET_EMPLOYEE_DETAILS,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }

  static getInactiveEmployees() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get("users/get-inactive-users");
        if (response.data) {
          dispatch({
            type: GET_INACTIVE_EMPLOYEE,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }

  static getWhoIsOutEmployees() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get("users/get-who-is-out");
        if (response.data) {
          dispatch({
            type: GET_WHO_IS_OUT_EMPLOYEE,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }

  static getEmployee(slug) {
    return async (dispatch) => {
      try {
        const response = await ApiService.get(`users/get/${slug}`);
        if (response.data) {
          dispatch({
            type: GET_EMPLOYEE,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }

  static getDiciplinaryCases() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get("disciplinary-cases");
        if (response.data) {
          dispatch({
            type: GET_DISCIPLINARY_CASE,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }

  static getAllCases() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get(
          "disciplinary-cases/get-all-cases"
        );
        if (response.data) {
          dispatch({
            type: GET_ALL_CASE,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/employeemanagement/employee.thunk.js